import React, { useState } from "react";
import ProfileBackgroundModal from "./ProfileBackgroundModal";
import ProfileSocialModal from "./ProfileSocialModal";
import { useSummonerProfile } from "api/summonerProfileApi";

const ProfileModalManager = (props) => {
  const { summonerName, regionId, setIsModalOpen, modalState } = props;
  const { loading: loadingProfileInit, data: profileInitData } = useSummonerProfile(regionId, summonerName, {}, null);
  const { customizationData } = (profileInitData && profileInitData.profileInit) || {};
  // const [currentModal, setCurrentModal] = useState(modalState === true ? "socialModal" : modalState);
  const [currentModal, setCurrentModal] = useState("backgroundModal");
  const modals = {
    socialModal: () => (
      <ProfileSocialModal
        swapModal={swapModal}
        customizationData={customizationData}
        summonerName={summonerName}
        regionId={regionId}
        setIsModalOpen={setIsModalOpen}
      />
    ),
    backgroundModal: () => <ProfileBackgroundModal swapModal={swapModal} />,
  };

  function swapModal(newModal) {
    if (modals[newModal]) {
      setCurrentModal(newModal);
    } else {
      console.error("MODAL NOT FOUND");
    }
  }

  return modals[currentModal]();
};

export default ProfileModalManager;
